import styled from 'styled-components';

const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 15px;
  width: 100%;
  margin-bottom: 20px;
  align-items: flex-end;
`;

const ModalContainer = styled.div`
  margin: 15px 0;
`;

const ModalHeaderContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  flex-wrap: wrap;
  font-size: 18px;
`;

export { ButtonContainer, ModalContainer, ModalHeaderContainer };
